import React, { Component } from 'react';
import { Field } from 'redux-form';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment-timezone';

import { fetchDropdown } from '../../../actions/actionCreators';
import { renderDefinedDropdown } from '../../common/form/FieldHelper';

class TimezoneDropdown extends Component {
  render() {
    const { name, form } = this.props;

    return (
      <div className="field">
        <Field
          {...this.props}
          filter="contains"
          name={name}
          formId={form}
          component={renderDefinedDropdown}
        />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      searchFn: fetchDropdown,
    },
    dispatch,
  );
}

function mapStateToProps() {
  return {
    data: moment.tz.names(),
    valueField: null,
    textField: null,
  };
}

TimezoneDropdown = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TimezoneDropdown);

export default TimezoneDropdown;
